import React from 'react';
import { Col, Row } from 'reactstrap';
import Card, { CardBody, CardHeader, CardTitle } from '../../components/Card';
import UploadEndpointSelect from '../../elements/User/Account/UploadEndpointSelect';
import { SequentialUploadsToggle } from '../../elements/User/Account/SequentialUploadsToggle';
import { getTranslationKey } from '../../modules/utils/helpers';

const UploadEndpoint: React.FC = () => (
  <div className="animated fadeIn">
    <Row>
      <Col sm="12" md="12" lg="6">
        <Card>
          <CardHeader>
            <CardTitle>{getTranslationKey('uploadEndpoint.title')}</CardTitle>
          </CardHeader>
          <CardBody>
            <p>{getTranslationKey('uploadEndpoint.description')}</p>
            <UploadEndpointSelect />
            <SequentialUploadsToggle />
          </CardBody>
        </Card>
      </Col>
    </Row>
  </div>
);

export default UploadEndpoint;
